<template>
  <div class="d-flex align-items-center justify-content-start">
    <label class="text-capitalize mb-0">{{ $t("table.show") }}</label>
    <v-select
      :value="perPage"
      @input="updatePerPage"
      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
      :options="perPageOptions"
      :clearable="false"
      class="per-page-selector d-inline-block mx-50"
    />
    <label class="text-capitalize mb-0">{{ $t("table.entries") }}</label>
  </div>
</template>

<script>
import vSelect from "vue-select";

export default {
  name: "PerPageSelector",
  components: {
    vSelect,
  },
  props: {
    perPage: {
      type: Number,
      required: true,
      default: 10,
    },
    perPageOptions: {
      type: Array,
      default: () => [10, 25, 50, 100],
    },
  },
  methods: {
    updatePerPage(value) {
      this.$emit("update:perPage", value);
    },
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>
